"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageStateHandler = void 0;
/**
 * Class that handles the page state in a singleton
 * stores the stimuli length and replay button state and modifier
 */
const taskSetup_1 = require("../../taskSetup");
//@ts-ignore
const roar_utils_1 = require("@bdelab/roar-utils");
const __1 = require("../../..");
class PageStateHandler {
    constructor(audioFile, playStimulusOnLoad) {
        this.audioFile = audioFile;
        if (typeof this.audioFile === 'string') {
            this.audioUri = __1.mediaAssets.audio[(0, roar_utils_1.camelize)(this.audioFile)] || __1.mediaAssets.audio.nullAudio;
        }
        else {
            this.audioUri = this.audioFile.map((audio) => __1.mediaAssets.audio[(0, roar_utils_1.camelize)(audio)]);
        }
        this.getbuffer();
        this.replayBtn = document.getElementById('replay-btn-revisited');
        this.playStimulusOnLoad = playStimulusOnLoad !== undefined ? playStimulusOnLoad : true;
    }
    async getbuffer() {
        if (this.audioBuffer) {
            return this.audioBuffer;
        }
        if (typeof this.audioUri === 'string') {
            this.audioBuffer = (await taskSetup_1.jsPsych.pluginAPI.getAudioBuffer(this.audioUri));
            return this.audioBuffer;
        }
        else {
            this.audioBuffer = (await Promise.all(this.audioUri.map(async (audio) => taskSetup_1.jsPsych.pluginAPI.getAudioBuffer(audio))));
            return this.audioBuffer;
        }
    }
    async getStimulusDurationMs() {
        const buffer = await this.getbuffer();
        if (buffer instanceof AudioBuffer) {
            return buffer.duration * 1000;
        }
        else {
            return buffer.reduce((acc, curr) => acc + curr.duration * 1000, 0);
        }
    }
    isReplayBtnEnabled() {
        return this.replayBtn.hasAttribute('disabled');
    }
    enableReplayBtn() {
        this.replayBtn.disabled = false;
    }
    disableReplayBtn() {
        this.replayBtn.disabled = true;
    }
}
exports.PageStateHandler = PageStateHandler;
